/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import { get, isEmpty, sortBy } from "lodash";
import React, { useEffect, useState } from "react";
import { getUser } from "../../../apis/auth";
import { useHistory, Link } from "react-router-dom";
import { cancelRequestCompany, cancelRequestEmployees, getCompanyToken } from "../../../apis/companies/companies";
import { getCareCompanies } from "../../../apis/admin/companies";
import { useDispatch } from "react-redux";
import { setProfile } from "../../../store/actions";
import Button from "../../../components/Button";
import Guide from "../../../components/Guide";
import { viewLoading } from "../../../utils/loading";
import systemAlert from "../../../utils/systemAlert";
import { classnames } from "../../../utils/text";
import { transformComNum } from "../../../utils/validator/comNum";
import consultingPopup from "../../../utils/consulting";

const SelectCompany = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = getUser();
  const [name, setName] = useState("");
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);

  const [careCompanies, setCareCompanies] = useState([]);
  const [selectedCareCompany, setSelectedCareCompany] = useState(null);

  const [isToggleCompany, setIsToggleCompany] = useState(false);
  const [isToggleCareCompany, setIsToggleCareCompany] = useState(false);

  useEffect(() => {
    const companies = get(history, "location.state.companies");
    setName(get(user, "name"));
    setCompanies(companies);
    setSelectedCompany(companies[0]);
  }, []);

  useEffect(() => {
    setCareCompanies([]);
    setSelectedCareCompany(null);
    // if (selectedCompany && selectedCompany.type !== 1) {
    if (selectedCompany && selectedCompany.type !== 1 && selectedCompany.state === 'joined') {
      viewLoading(true);
      getCareCompanies(
        selectedCompany.companyIdx,
        selectedCompany.type
      )
        .then((res) => {
          //setCareCompanies([selectedCompany, ...res.data.companies])
          setCareCompanies([selectedCompany, ...sortBy(res.data.companies, ["name"])]);
          setSelectedCareCompany(selectedCompany);

        }).finally(() => viewLoading(false));

    }
  }, [selectedCompany]);

  // const handleOnChange = (e) => {
  //   const { value } = e.target;
  //   const selectCompany = companies.find(c => String(c.companyIdx) === String(value))
  //   setSelectedCompany(selectCompany);
  // };

  // const careCompanyHandleOnChange = (e) => {
  //   const { value } = e.target;
  //   const selectCompany = careCompanies.find(c => String(c.companyIdx) === String(value))
  //   setSelectedCareCompany(selectCompany);
  // };

  const handleSelectCompany = () => {
    const companyIdx = (selectedCareCompany || selectedCompany).companyIdx;
    const type = selectedCompany.type;

    viewLoading(true);
    getCompanyToken({ companyIdx, type })
      .then(() => {
        dispatch(setProfile());
        history.push("/dashboard");
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        viewLoading(false);
      });
  };

  const handleCancelRequest = () => {
    systemAlert(`${selectedCompany.name}의 직원 요청을 취소하시겠습니까?`, {
      buttons: [
        {
          label: '확인', onClick: () => {
            cancelRequestEmployees(selectedCompany.companyIdx).then(() => {
              history.push('/logout');
            });
          }
        },
        { label: '취소', color: 'text' }
      ]
    });
  };

  const handleCancelRequestCompany = () => {
    systemAlert(`${selectedCompany.name} 기업 등록 요청을 취소하시겠습니까?`, {
      buttons: [
        {
          label: '확인', onClick: () => {
            cancelRequestCompany(selectedCompany.companyIdx).then(() => {
              history.push('/logout');
            });
          }
        },
        { label: '취소', color: 'text' }
      ]
    });
  };

  const handleOnClickCompany = (idx) => {
    setSelectedCompany(companies[idx]);
    setIsToggleCompany(false);
  };

  const handleOnClickCareCompany = (idx) => {
    setSelectedCareCompany(careCompanies[idx]);
    setIsToggleCareCompany(false);
  };

  return (
    <div className="page-layout auth-wrap">
      <div className="select-company-container">
        <p className="title">안녕하세요, {name}님</p>
        <p className="sub-title mt-64">소속회사를 선택해주세요</p>
        {/* <select
          className="select-box"
          onChange={handleOnChange}
        >
          {companies.map((company, idx) => (
            <option
              key={idx}
              value={company.companyIdx}
            >
              {`${company.name}/${company.comNum}/${company.ceoName}`}
            </option>
          ))}
        </select> */}
        <div className="custom-select-container">
          <div className="custom-selected-view" onClick={() => {
            setIsToggleCompany(!isToggleCompany);
            setIsToggleCareCompany(false);
          }}>
            <p className="company-name">
              {get(selectedCompany, 'type') === 2 && "[세무사] "}
              {get(selectedCompany, 'type') === 3 && "[노무사] "}
              {get(selectedCompany, 'type') === 9 && "[경리대행] "}
              {get(selectedCompany, 'name')}
            </p>
            <div className="company-info-wrap">
              <span className="company-num">{transformComNum(get(selectedCompany, 'comNum'))}</span>
              <span className="ceo">대표</span><span className="company-ceo-name">{get(selectedCompany, 'ceoName')}</span>
            </div>
          </div>
          <ul className={classnames("custom-options-view", { open: isToggleCompany })}>
            {companies.map((company, idx) => (
              <li key={idx} className="custom-options" onClick={() => handleOnClickCompany(idx)}>
                <p className="company-name">
                  {company.type === 2 && "[세무사] "}
                  {company.type === 3 && "[노무사] "}
                  {company.type === 9 && "[경리대행] "}
                  {company.name}
                </p>
                <div className="company-info-wrap">
                  <span className="company-num">{transformComNum(company.comNum)}</span>
                  <span className="ceo">대표</span><span className="company-ceo-name">{company.ceoName}</span>
                </div>
              </li>
            ))}
          </ul>
        </div>
        {!isEmpty(careCompanies) &&
          <>
            <p className="sub-title mt-24">업무를 수행할 담당회사를 선택해주세요</p>
            <div className="custom-select-container">
              <div className="custom-selected-view" onClick={() => {
                setIsToggleCareCompany(!isToggleCareCompany);
                setIsToggleCompany(false);
              }}>
                <p className="company-name">
                  {get(selectedCareCompany, 'type') === 2 && "[세무사] "}
                  {get(selectedCareCompany, 'type') === 3 && "[노무사] "}
                  {get(selectedCareCompany, 'type') === 9 && "[경리대행] "}
                  {get(selectedCareCompany, 'name')}
                </p>
                <div className="company-info-wrap">
                  <span className="company-num">{transformComNum(get(selectedCareCompany, 'comNum'))}</span>
                  <span className="ceo">대표</span><span className="company-ceo-name">{get(selectedCareCompany, 'ceoName')}</span>
                </div>
              </div>
              <ul className={classnames("custom-options-view", { open: isToggleCareCompany })}>
                {careCompanies.map((company, idx) => (
                  <li key={idx} className="custom-options" onClick={() => handleOnClickCareCompany(idx)}>
                    <p className="company-name">
                      {company.type === 2 && "[세무사] "}
                      {company.type === 3 && "[노무사] "}
                      {company.type === 9 && "[경리대행] "}
                      {company.state === 'pause' && "(일시중지) "}
                      {company.name}
                    </p>
                    <div className="company-info-wrap">
                      <span className="company-num">{transformComNum(company.comNum)}</span>
                      <span className="ceo">대표</span><span className="company-ceo-name">{company.ceoName}</span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            {/* <select
              className="select-box mt-15"
              onChange={careCompanyHandleOnChange}
            >
              {careCompanies.map((company, idx) => (
                <option
                  key={idx}
                  value={company.companyIdx}
                >
                  {company.type === 2 && "[세무사] "}
                  {company.type === 3 && "[노무사] "}
                  {company.type === 9 && "[경리대행] "}
                  {`${company.name}/${company.comNum}/${company.ceoName}`}
                </option>
              ))}
            </select> */}
          </>
        }
        {selectedCompany &&
          <div className="btn-wrap clear">
            {selectedCompany.state === 'requested' && !selectedCareCompany &&
              <>
                <Guide
                  className="requested"
                  children="직원 등록요청 승인대기중"
                />
                <button className="cancel-request-button" onClick={handleCancelRequest}>요청취소</button>
              </>
            }
            {selectedCompany.state === 'wait' && !selectedCareCompany &&
              <>
                <Guide
                  className="requested"
                  children="기업 등록요청 승인대기중"
                />
                <button className="cancel-request-button" onClick={handleCancelRequestCompany}>요청취소</button>
              </>
            }
            {(selectedCompany.state === 'pause' || (selectedCareCompany && selectedCareCompany.state === 'pause')) &&
              <>
                <Guide
                  className="requested"
                  children="일시중지된 기업입니다."
                />
              </>
            }
            {(selectedCompany.state === 'joined' && (!selectedCareCompany || (selectedCareCompany && selectedCareCompany.state !== 'pause'))) &&
              <Button
                className="w-full mt-24"
                size="lg"
                onClick={handleSelectCompany}
              >
                회사 접속하기
              </Button>
            }
          </div>
        }
        <div className="divider mt-40" />
        <Button
          className="w-full mt-24"
          label="다른 회사에 직원 등록요청"
          color="secondary"
          size="lg"
          onClick={() => history.push('/join-company')}
        />
        <Button
          className="w-full mt-12"
          label="신규기업 등록"
          color="secondary"
          size="lg"
          onClick={() => history.push('/create-company')}
        />
        <div className="inquire-wrap float-left">
          <div className="inquire-button-wrap">
            <a
              className="cursor-pointer"
              onClick={() => {
                consultingPopup(true);
              }}
            >WeCake에 문의</a>
          </div>
        </div>
        <div className="inquire-wrap float-right">
          <div className="logout-button-wrap">
            <Link to="/logout">로그아웃</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectCompany;
